import React from 'react';

export const Error = (props) => {
    return (
        <div className="container errorPage">
            <div className="d-flex flex-column align-items-center">
                {props.children}
                <div className="d-flex flex-column align-items-center text-center">
                    <strong>משהו קרה והעמוד לא עולה</strong>
                    <span>אנחנו בודקים ומטפלים, נסו אותנו שוב עוד מעט</span>
                </div>
            </div>
        </div>
    );
}